import React, { useState } from 'react';
import './App.css';
import api from './api';
import Dashboard from './components/Dashboard';
import AddOrder from './components/AddOrder';
import Customers from './components/Customers';
import BillOfLading from './components/BillOfLading';
import BolLog from './components/BolLog';
import History from './components/History';
import PartsMaster from './components/PartsMaster';
import Admin from './components/Admin';

function decodeRole(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.role || 'office';
  } catch { return 'office'; }
}

function Login({ onLogin }) {
  const [u, setU] = useState('');
  const [p, setP] = useState('');
  const [err, setErr] = useState('');
  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    try {
      const { data } = await api.post('/api/users/login', { username: u, password: p });
      localStorage.setItem('token', data.token);
      localStorage.setItem('username', data.username);
      localStorage.setItem('role', data.role || decodeRole(data.token));
      onLogin();
    } catch (e) {
      setErr('Login failed');
    }
  };
  return (
    <div className="login-bg">
      <div className="card login-card">
        <h2 style={{ textAlign: 'center', color: '#1a3a5c', marginTop: 0 }}>Tailored Packaging LLC</h2>
        <p style={{ textAlign: 'center', color: '#666', marginTop: 0 }}>Order Management CRM</p>
        <form onSubmit={submit}>
          <div className="field"><label>Username</label><input value={u} onChange={e => setU(e.target.value)} /></div>
          <div className="field"><label>Password</label><input type="password" value={p} onChange={e => setP(e.target.value)} /></div>
          {err && <div style={{ color: '#e74c3c', marginBottom: 8 }}>{err}</div>}
          <button type="submit" className="btn-primary" style={{ width: '100%' }}>Sign In</button>
        </form>
      </div>
    </div>
  );
}

const TABS = [
  { id: 'dashboard', label: '📊 Dashboard', C: Dashboard },
  { id: 'add', label: '➕ Add Order', C: AddOrder },
  { id: 'customers', label: '👥 Customers', C: Customers },
  { id: 'bol', label: '📋 Bill of Lading', C: BillOfLading },
  { id: 'bollog', label: '📁 BOL Log', C: BolLog },
  { id: 'history', label: '🗂 History', C: History },
  { id: 'parts', label: '⚙️ Parts Master', C: PartsMaster },
  { id: 'admin', label: '🔐 Admin', C: Admin, adminOnly: true },
];

export default function App() {
  const [authed, setAuthed] = useState(!!localStorage.getItem('token'));
  const [tab, setTab] = useState('dashboard');
  const role = localStorage.getItem('role') || 'office';
  const username = localStorage.getItem('username') || '';

  if (!authed) return <Login onLogin={() => setAuthed(true)} />;

  const tabs = TABS.filter(t => !t.adminOnly || role === 'admin');
  const Active = (tabs.find(t => t.id === tab) || tabs[0]).C;

  const logout = () => { localStorage.clear(); setAuthed(false); };

  return (
    <div>
      <div className="nav no-print">
        <div className="brand">Tailored Packaging LLC</div>
        {tabs.map(t => (
          <div key={t.id} className={'tab' + (tab === t.id ? ' active' : '')} onClick={() => setTab(t.id)}>{t.label}</div>
        ))}
        <div className="spacer" />
        <div className="user">{username} ({role})</div>
        <button className="btn-orange" onClick={logout}>Logout</button>
      </div>
      <div className="page"><Active role={role} /></div>
    </div>
  );
}
